
<template>
  <div>
    <van-nav-bar
      title="公告通知"
      fixed
      placeholder
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <div class="mt-2">
      <van-cell-group border="true">
        <van-cell
          v-for="(notice, idx) in notices"
          :key="idx"
          :title="notice.title"
          is-link
          icon="volume-o"
          @click="showNotice(notice.id)"
        >
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getNotices} from "@/service/home";
import { Dialog } from "vant";
export default {
  name: "notices",
  components: { [Dialog.Component.name]: Dialog.Component },
  setup() {
    const router = useRouter();
    const state = reactive({
      notices: []
    });
    const goBack = () => router.go(-1);
    const showNotice = async (id) => {
      router.push({ name: 'noticeDetail', params: { id: id } })
    };

    onMounted(async () => {
      const { data:{list} } = await getNotices();
      state.notices = list;
    });
    return {
      goBack,
      showNotice,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" >
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
.van-cell__title {
  flex: 1 1 auto;
}
.van-cell__value {
  flex: 1 1 auto;
}
</style>
